import * as React from "react"
import SelectProject from "./select_project"

export default function SelectProjectApp(props) {
  return <SelectProject {...props} />
}